import { __awaiter, __extends, __generator } from "tslib";
import { GraphQLOperations } from '../constants';
import { queries as deprecatedQueries } from '../../graphql/deprecated.graphql';
import { BaseApi } from '../BaseApi';
import { BIService } from '../BIService';
var CartApi = /** @class */ (function (_super) {
    __extends(CartApi, _super);
    function CartApi(_a) {
        var siteStore = _a.siteStore, origin = _a.origin;
        var _this = _super.call(this, { siteStore: siteStore, origin: origin }) || this;
        _this.biService = new BIService({ siteStore: siteStore, origin: origin });
        return _this;
    }
    CartApi.prototype.createVolatileCart = function (variables) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mutate({
                            variables: variables,
                            query: deprecatedQueries.createVolatileCartMutation,
                            operationName: GraphQLOperations.CreateCart,
                        })];
                    case 1: return [2 /*return*/, (_a.sent()).checkout.createCart];
                }
            });
        });
    };
    return CartApi;
}(BaseApi));
export { CartApi };
//# sourceMappingURL=CartApi.js.map